import VuexHelper from '@/utilities/service/vuex/Helper'

const helper = new VuexHelper(require.context('.', true, /index\.js$/))
const modules = helper.modules()

export default {
  namespaced: true,
  modules,
}
